import { type SupportedLocaleMap } from '@zep-us/i18n';
import { useTranslation } from 'next-i18next';
import { CMS_CDN } from '@/consts/env';
import { useLocale } from '@/hooks';
import { FunctionCard, FunctionCards } from '@/shared/components';
export const Ai = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <section className="px-[16px] py-2xl min-[751px]:px-[24px] min-[1025px]:px-[40px] min-[1025px]:py-3xl" data-sentry-component="Ai" data-sentry-source-file="Ai.tsx">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-lg min-[751px]:items-stretch min-[751px]:gap-2xl min-[1025px]:gap-3xl">
        <div className="flex flex-col-reverse items-center gap-[10px] px-[16px] min-[751px]:flex-row">
          <h2 className="text-center text-display-sm-extrabold text-default min-[751px]:whitespace-normal min-[751px]:text-left">
            {t('landingV3.aiFeatures.title')}
          </h2>
        </div>
        <FunctionCards topElement={<Function1 />} bottomLeftElement={<Function2 />} bottomRightElement={<Function3 />} data-sentry-element="FunctionCards" data-sentry-source-file="Ai.tsx" />
      </div>
    </section>;
};
const FUNCTION_1_IMAGE_LINKS: SupportedLocaleMap<'ko' | 'en' | 'ja'> = {
  ko: `${CMS_CDN}/medias/9z7bCJzn/I1R/baIa43wK87XuPSd0EbYSI1R/en-US/1/v3_2_1_image_kr_2x.webp`,
  en: `${CMS_CDN}/medias/9z7bCJzn/s4S/OHSjy3wK87XuPScqFzcbs4S/en-US/1/v3_2_1_image_en_2x.webp`,
  ja: `${CMS_CDN}/medias/9z7bCJzn/8fo/f3fcj3wK886uPScK5RdY8fo/en-US/1/v3_2_1_image_ja_2x.webp`
};
const Function1 = () => {
  const {
    locale
  } = useLocale();
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <FunctionCard.HorizontalWrapper className="bg-green-50" data-sentry-element="unknown" data-sentry-component="Function1" data-sentry-source-file="Ai.tsx">
      <div className="flex-1">
        <div className="flex size-full flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pr-0 min-[1025px]:p-3xl min-[1025px]:pr-0">
          <div className="flex flex-col items-center gap-md min-[751px]:items-stretch">
            <FunctionCard.Title className="text-mint-900" data-sentry-element="unknown" data-sentry-source-file="Ai.tsx">
              {t('landingV3.aiFeature1.title')}
            </FunctionCard.Title>
          </div>
          <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="Ai.tsx">
            {t('landingV3.aiFeature1.content')}
          </FunctionCard.Description>
        </div>
      </div>

      <div className="flex-1 min-[751px]:h-[310px] min-[1025px]:h-[374px]">
        <img src={FUNCTION_1_IMAGE_LINKS[locale] ?? FUNCTION_1_IMAGE_LINKS.en} alt="unlimited AI quiz" className="size-full min-[751px]:object-cover min-[751px]:object-left" />
      </div>
    </FunctionCard.HorizontalWrapper>;
};
const FUNCTION_2_IMAGE_LINKS: SupportedLocaleMap<'ko' | 'en' | 'ja'> = {
  ko: `${CMS_CDN}/medias/9z7bCJzn/JCO/fDY0r3wK886uPSfrdJqOJCO/en-US/1/v3_2_2_image_kr_2x.webp`,
  en: `${CMS_CDN}/medias/9z7bCJzn/2wf/ezWDT3wK87XuPScqFxEK2wf/en-US/1/v3_2_2_image_en_2x.webp`,
  ja: `${CMS_CDN}/medias/9z7bCJzn/2kj/U6CKS3wK87XuPScK5PLi2kj/en-US/1/v3_2_2_image_ja_2x.webp`
};
const Function2 = () => {
  const {
    locale
  } = useLocale();
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <FunctionCard.VerticalWrapper className="bg-green-100" data-sentry-element="unknown" data-sentry-component="Function2" data-sentry-source-file="Ai.tsx">
      <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
        <FunctionCard.Title className="text-mint-900" data-sentry-element="unknown" data-sentry-source-file="Ai.tsx">
          {t('landingV3.aiFeature2.title')}
        </FunctionCard.Title>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="Ai.tsx">
          {t('landingV3.aiFeature2.content')}
        </FunctionCard.Description>
      </div>

      <img src={FUNCTION_2_IMAGE_LINKS[locale] ?? FUNCTION_2_IMAGE_LINKS.en} alt="easy and fast AI quiz" />
    </FunctionCard.VerticalWrapper>;
};
const FUNCTION_3_IMAGE_LINKS: SupportedLocaleMap<'ko' | 'en' | 'ja'> = {
  ko: `${CMS_CDN}/medias/9z7bCJzn/SPO/BdNt13wK87XuPSfrdJIdSPO/en-US/1/v3_2_3_image_kr_2x.webp`,
  en: `${CMS_CDN}/medias/9z7bCJzn/w8t/DIrAk3wK886uPScqFymCw8t/en-US/1/v3_2_3_image_en_2x.webp`,
  ja: `${CMS_CDN}/medias/9z7bCJzn/cAB/9bD0c3wK886uPScK5RvKcAB/en-US/1/v3_2_3_image_ja_2x.webp`
};
const Function3 = () => {
  const {
    locale
  } = useLocale();
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <FunctionCard.VerticalWrapper className="bg-[#F0F7F1]" data-sentry-element="unknown" data-sentry-component="Function3" data-sentry-source-file="Ai.tsx">
      <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
        <FunctionCard.Title className="text-mint-900" data-sentry-element="unknown" data-sentry-source-file="Ai.tsx">
          {t('landingV3.aiFeature3.title')}
        </FunctionCard.Title>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="Ai.tsx">
          {t('landingV3.aiFeature3.content')}
        </FunctionCard.Description>
      </div>

      <img src={FUNCTION_3_IMAGE_LINKS[locale] ?? FUNCTION_3_IMAGE_LINKS.en} alt="AI quiz using uploaded files" />
    </FunctionCard.VerticalWrapper>;
};